import { defineComponent as _defineComponent } from 'vue'
import GlobalLoading from '@/HostApp/ui/system/GlobalLoading.vue';
	import ComputedLayout from '@/HostApp/ui/components/layout/ComputedLayout.vue';
	import { useLayoutTemplate } from '@/HostApp/services/SystemLayout/SystemLayoutModule';

	
	const __default__ = {
		name: 'SystemLayout',
		inheritAttrs: false
	};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

	const { grid, items } = useLayoutTemplate();

return { __sfc: true,grid, items, GlobalLoading, ComputedLayout }
}

})